import { useEffectOnce } from "@be-miniapp/ui/hooks/use-effect-once"

/**
 * AppView: `addEventListener` (multiple listeners OK).
 * Zalo: assigns `window.onpopstate` (singleton) — preserves current runtime behavior.
 */
export type FarePopStateStrategy = "addEventListener" | "assignOnPopState"

export function useFarePopStateHandler(opts: {
  strategy: FarePopStateStrategy
  navigate: (to: string, options?: { replace?: boolean }) => void
}) {
  const { strategy, navigate } = opts

  useEffectOnce(() => {
    if (strategy === "addEventListener") {
      const handlePopState = () => {
        navigate("/ride/home", { replace: true })
      }
      window.addEventListener("popstate", handlePopState)
      return () => {
        window.removeEventListener("popstate", handlePopState)
      }
    }

    window.onpopstate = () => {
      navigate("/ride/home", { replace: true })
    }
    return () => {
      window.onpopstate = null
    }
  })
}
